import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { IHALE_DURUMLARI, labelOf } from './constants';
import { tesisTuruText } from '../../../utils/tesisTuru';

export function IhaleTable({
  data, ihaleler, selectedRows, setSelectedRows,
  displayMoney, user, openEditDialog, handleDelete,
  onRowClick, onOpenExport, selectedColumns, setSelectedColumns
}) {
  const parseMoney = (val) => {
    const num = parseFloat((val || '').replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.'));
    return isNaN(num) ? 0 : num;
  };

  const sumField = (items, field) => {
    let total = 0;
    items.forEach(i => { total += parseMoney(i[field]); });
    return total.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL';
  };

  return (
    <>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-900 border-b border-gray-800">
            <tr>
              <th className="px-4 py-3 text-center">
                <input type="checkbox" checked={selectedRows.length === data.length && data.length > 0}
                  onChange={(e) => setSelectedRows(e.target.checked ? data.map(i => i.id) : [])} className="w-4 h-4" />
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400">S.NO</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400">Yıl</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400">İhale No</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400">İşin Adı</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400">İlçe</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400" data-testid="ihale-table-th-tesis-turu">Tesis Türü</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400">Durum</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400">Firma</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-400">Yaklaşık Maliyet</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-400">Sözleşme Bedeli</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-400">Hakediş</th>
              {user?.is_admin && <th className="px-4 py-3 text-left text-xs font-medium text-gray-400">Son Düzenleyen</th>}
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-400">İşlemler</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            {data.map((ihale, index) => (
              <tr key={ihale.id} className={`${selectedRows.includes(ihale.id) ? 'bg-blue-900/30' : 'bg-gray-900/50'} hover:bg-gray-800/70 cursor-pointer`}
                onClick={(e) => {
                  if (e.target.tagName === 'INPUT' || e.target.tagName === 'BUTTON' || e.target.closest('button')) return;
                  onRowClick(ihale);
                }}>
                <td className="px-4 py-3 text-center">
                  <input type="checkbox" checked={selectedRows.includes(ihale.id)}
                    onChange={(e) => setSelectedRows(e.target.checked ? [...selectedRows, ihale.id] : selectedRows.filter(id => id !== ihale.id))} className="w-4 h-4" />
                </td>
                <td className="px-4 py-3 text-sm text-gray-400">{index + 1}</td>
                <td className="px-4 py-3 text-sm text-white">{ihale.yil}</td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm text-white cursor-pointer hover:text-blue-400">{ihale.ihale_no}</td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm text-gray-300 max-w-md truncate cursor-pointer hover:text-blue-400">{ihale.isin_adi}</td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm text-gray-300 cursor-pointer hover:text-blue-400">{ihale.ilcesi}</td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm text-gray-300 cursor-pointer hover:text-blue-400" data-testid={`ihale-row-tesis-turu-${ihale.id}`}>{tesisTuruText(ihale.tesis_turu) || '-'}</td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm cursor-pointer">
                  <Badge className="bg-blue-500/20 text-blue-400 border-blue-500/50">{labelOf(IHALE_DURUMLARI, ihale.durumu) || '-'}</Badge>
                </td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm text-gray-300 max-w-xs truncate cursor-pointer hover:text-blue-400">{ihale.ihaleyi_alan_firma || '-'}</td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm text-gray-300 text-right cursor-pointer hover:text-blue-400">{displayMoney(ihale.yaklasik_maliyet)}</td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm text-gray-300 text-right cursor-pointer hover:text-blue-400">{displayMoney(ihale.sozlesme_bedeli)}</td>
                <td onClick={() => onRowClick(ihale)} className="px-4 py-3 text-sm text-gray-300 text-right cursor-pointer hover:text-blue-400">{displayMoney(ihale.toplam_odenen_hakedis)}</td>
                {user?.is_admin && (
                  <td className="px-4 py-3 text-xs text-gray-400">
                    <div>{ihale.last_modified_by_name || '-'}</div>
                    {ihale.last_modified_at && <div className="text-gray-500 text-xs mt-1">{new Date(ihale.last_modified_at).toLocaleString('tr-TR')}</div>}
                  </td>
                )}
                <td className="px-4 py-3 text-right">
                  <div className="flex gap-2 justify-end">
                    {!user?.is_viewer && (
                      <Button onClick={() => openEditDialog(ihale)} size="sm" variant="outline" className="bg-gray-800 border-gray-700 text-white hover:bg-gray-700">Düzenle</Button>
                    )}
                    {user?.is_admin && (
                      <Button onClick={() => handleDelete(ihale.id)} size="sm" variant="outline" className="bg-red-900/20 border-red-700 text-red-400 hover:bg-red-900/40">Sil</Button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            <tr className="bg-blue-900/20 border-t-2 border-blue-700">
              <td colSpan="9" className="px-4 py-3 text-sm font-bold text-blue-300 text-right">TOPLAM:</td>
              <td className="px-4 py-3 text-sm font-bold text-blue-300 text-right">{sumField(ihaleler, 'yaklasik_maliyet')}</td>
              <td className="px-4 py-3 text-sm font-bold text-blue-300 text-right">{sumField(ihaleler, 'sozlesme_bedeli')}</td>
              <td className="px-4 py-3 text-sm font-bold text-blue-300 text-right">{sumField(ihaleler, 'toplam_odenen_hakedis')}</td>
              <td colSpan={user?.is_admin ? 2 : 1}></td>
            </tr>
          </tbody>
        </table>
      </div>

      {selectedRows.length > 0 && (
        <Card className="mt-6 bg-gradient-to-br from-blue-900/30 to-purple-900/30 border-blue-700/50">
          <CardHeader>
            <CardTitle className="text-blue-400" data-testid="selected-summary-title">Seçili İhaleler Toplamı ({selectedRows.length} ihale)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <p className="text-xs text-gray-400 mb-1">Yaklaşık Maliyet:</p>
                <p className="text-lg font-bold text-blue-300">{sumField(ihaleler.filter(i => selectedRows.includes(i.id)), 'yaklasik_maliyet')}</p>
              </div>
              <div>
                <p className="text-xs text-gray-400 mb-1">Sözleşme Bedeli:</p>
                <p className="text-lg font-bold text-blue-300">{sumField(ihaleler.filter(i => selectedRows.includes(i.id)), 'sozlesme_bedeli')}</p>
              </div>
              <div>
                <p className="text-xs text-gray-400 mb-1">Toplam Hakediş:</p>
                <p className="text-lg font-bold text-blue-300">{sumField(ihaleler.filter(i => selectedRows.includes(i.id)), 'toplam_odenen_hakedis')}</p>
              </div>
            </div>
            <div className="mt-4 flex gap-3">
              <Button onClick={() => { onOpenExport(); if (selectedColumns.length === 0) setSelectedColumns(['ihale_no', 'isin_adi', 'ilcesi', 'durumu', 'yaklasik_maliyet']); }}
                className="bg-purple-600 hover:bg-purple-700 text-white" data-testid="selected-export-btn">
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                Seçilileri İndir (PDF/Excel)
              </Button>
              <Button onClick={() => setSelectedRows([])} variant="outline" className="bg-gray-800 border-gray-700 text-white hover:bg-gray-700">Seçimi Temizle</Button>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
